import { useRef, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { Link } from 'react-router-dom';
import { routes } from 'utils/routes';
import { authService } from 'services';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'redux/store';
import CustomToast from 'views/components/form-inputs/alert/index';
import { Message } from 'primereact/message';
import { showTostify } from 'utils/common-functions';
import { setLoggedInUser, setTokenSession } from '../../../redux/slices/session.slice';
import { AuthImg } from './images';
import Logo from 'assets/images/logo.svg';
import './style.scss';
import SEOHeader from 'views/components/seo-header';

const Login = () => {
  const toastRef = useRef<any>(null);
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      email: '',
      password: ''
    },
    validationSchema: Yup.object({
      email: Yup.string().required().label('Email or username'),
      password: Yup.string().label('Password').required()
    }),
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const data = await authService.login(values);
        if (data.error === false) {
          showTostify(toastRef, 'success', data.message);
          setTimeout(() => {
            dispatch(setTokenSession(data?.access_token));
            dispatch(setLoggedInUser());
          }, 1000)
        } else {
          showTostify(toastRef, 'error', data.message);
        }
      } catch (err: any) {
        showTostify(toastRef, 'error', err.message);
      } finally {
        setLoading(false);
      }
    }
  });

  return (
    <>
      <SEOHeader title="Login" />
      <div className="auth-details flex h-screen">
        <CustomToast ref={toastRef} />
        <div className="flex align-items-center justify-content-center flex-column w-6">
          <div className="login-width">
            <form onSubmit={formik.handleSubmit}>
              <img src={Logo} alt="Clapping Hands" className='w-13rem' />
              <h2 className="flex align-items-center my-2">Welcome Back &nbsp;</h2>
              <p className="mb-4">Enter your credentials to shape today&apos;s success!.</p>

              <div className="form-group">
                <div className="login-input">
                  <label htmlFor="email">Email or Username<span className='required-field'>*</span></label>
                  <InputText
                    id="email"
                    name="email"
                    className={`form-control ${formik.errors.email && formik.touched.email ? 'p-invalid' : ''}`}
                    value={formik.values.email}
                    placeholder="Enter here"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.email && formik.errors.email && (
                    <Message severity="error" text={formik.errors.email} />
                  )}
                </div>
              </div>

              <div className="form-group login-password-field">
                <div className="login-input">
                  <label htmlFor="password">Password<span className='required-field'>*</span></label>
                  <Password
                    id="password"
                    name="password"
                    value={formik.values.password}
                    placeholder="Enter here"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={`form-control ${formik.errors.email && formik.touched.email ? 'p-invalid' : ''}`}
                    toggleMask
                    feedback={false}
                  />
                  {formik.touched.password && formik.errors.password && (
                    <Message severity="error" text={formik.errors.password} />
                  )}
                </div>
              </div>

              <div className="flex justify-content-end my-3">
                <p className='m-0'>
                  <Link to={routes.forgotPassword} className="btn-link">
                    Forgot password
                  </Link>
                </p>
              </div>

              {/* <div className="flex justify-content-center"> */}
              <Button
                label={loading ? "" : 'Login'}
                type="submit"
                className="primary w-full"
                disabled={!formik.isValid || formik.isSubmitting || loading}
                loading={loading}
              />
              {/* </div> */}
            </form>
          </div>

          <div className='copy-right'>
            <p className='m-0'>© 2024 Bookmydiscount, All rights reserved.</p>
          </div>
        </div>

        <div className="flex justify-content-end align-items-center bg-white w-6 p-4 right-images">
          <div className="img-container">
            <img src={AuthImg} className="character-image" alt="Login Banner" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;